import { Button } from "@/components/ui/button";
import LocaleLink from "@/components/LocaleLink";
import { Calendar, ArrowRight, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";

const FinalCTABand = () => {
  const { t } = useTranslation();

  return (
    // The page's second Brand Ink anchor. OneControl took the first one and
    // merging spent the other, which left the last two screens with nothing
    // dark in them. The close is where a dark band belongs anyway.
    <section className="py-16 bg-brand-ink text-brand-ink-foreground border-y border-brand-ink">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="section-title-fluid font-bold">
            {t("finalCtaBand.title")}
          </h2>
          <p className="text-lg text-brand-ink-foreground/75">
            {t("finalCtaBand.subtitle")}
          </p>

          <div className="pt-2 flex flex-col gap-4 sm:grid sm:w-fit sm:grid-flow-col sm:auto-cols-fr sm:mx-auto">
            <Button asChild size="lg" className="gap-2 w-full">
              <LocaleLink to="/platform-demo">
                <Calendar className="h-4 w-4" />
                {t("finalCtaBand.bookDemo")}
                <ArrowRight className="h-4 w-4" />
              </LocaleLink>
            </Button>

            <Button asChild variant="outline" size="lg" className="gap-2 border-brand-ink-foreground/35 text-brand-ink-foreground hover:bg-brand-ink-foreground hover:text-brand-ink w-full">
              <a href="https://app.csquaregrc.com/subscribe" target="_blank" rel="noopener noreferrer">
                {t("finalCtaBand.startFree")}
              </a>
            </Button>
          </div>

          <p className="text-sm text-brand-ink-foreground/70 pt-2">
            {t("finalCtaBand.salesPrompt")}{" "}
            <a
              href="mailto:hello@csquaregrc.com"
              className="text-trail-teal font-medium hover:underline inline-flex items-center gap-1"
            >
              <Mail className="w-3.5 h-3.5" />
              {t("finalCtaBand.contactSales")}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTABand;
